<template>
  <div>
    <DisplayRecipe
      v-for="recipe in firstRecipes"
      :key="recipe.id"
      class="mt-2 p-element-page"
      :id="recipe.id"
      :title="recipe.title"
      :slug="recipe.slug"
      :category_name="recipe.name"
      :img="recipe.img"
      :img_small="recipe.img_cover"
      :start_date="recipe.recipe_date"
      :video_link="recipe.video_link"
    />

    <div class="container-a mt-2" v-if="$screen.showMobileAds">
      <AdsEventMobile />
    </div>

    <DisplayRecipe
      v-for="recipe in secondRecipes"
      :key="recipe.id"
      class="mt-2 p-element-page"
      :id="recipe.id"
      :title="recipe.title"
      :slug="recipe.slug"
      :category_name="recipe.name"
      :img="recipe.img"
      :img_small="recipe.img_cover"
      :start_date="recipe.recipe_date"
      :video_link="recipe.video_link"
    />
  </div>
</template>

<script setup>
import DisplayRecipe from './DisplayBlock.vue'
import AdsEventMobile from '~/components/GoogleAdvertisements/AdsEventMobile.vue'

const props = defineProps({
  recipes: { type: Array, default: () => [] },
  isDesktop: { type: Boolean, default: false },
  devOrProd: { type: Boolean, default: false },
})

const firstRecipes = computed(() => props.recipes.slice(0, 4))
const secondRecipes = computed(() => props.recipes.slice(4, 12))

// Ako baš hoćeš helper kao ranije:
const itemsSlice = (items, from, to) => (items ?? []).slice(from, to)
</script>

<style>
/* tvoji stilovi ostaju */
</style>
